import isSameCallback, { isDuplicateCallback } from '../../_helpers/issamecallback.js';
// tells whether an internal delegation event (like "_change:delegated:KEY") belongs to a delegated listener
// callback and context are compared only when they're given, or always when exact is true
export default function matchesDelegation(event, _ref, exact) {
  var pathStr = _ref.pathStr,
    name = _ref.name,
    callback = _ref.callback,
    context = _ref.context;
  if (exact === void 0) {
    exact = false;
  }
  var _event$info = event.info,
    eventPathStr = _event$info.pathStr,
    delegatedData = _event$info.delegatedData;
  if (eventPathStr !== pathStr || !delegatedData || delegatedData.name !== name) {
    return false;
  }
  if (exact) {
    return isDuplicateCallback(callback, delegatedData.callback) && delegatedData.context === context;
  }
  return (!callback || isSameCallback(callback, delegatedData.callback)) && (!context || context === delegatedData.context);
}